import {
  Component,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { IImage } from '../../interfaces/definitions';
import { Storage } from '../../services/storage';
import { HttpHeaders, HttpEvent, HttpEventType } from '@angular/common/http';
import { IResponse } from 'response-type';
import { UtilsService } from '../../services/utils.service';
import { ngdTranslate } from '../../translations';
import { RequestsService } from '../../services/requests.service';
declare var require: any;
const uuid = require('uuid/v1');

@Component({
  selector: 'ng-media-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent {
  public active = false;
  public message = '';
  @Output() public uploadFinish: EventEmitter<any> = new EventEmitter();
  @Output() public fileEvent: EventEmitter<any> = new EventEmitter();
  @Output() public uploadFailed: EventEmitter<any> = new EventEmitter();
  @Output() public uploadProgress: EventEmitter<any> = new EventEmitter();

  @Input() public storage: Storage = null;
  @ViewChild('inputFile', { static: false }) inputFile: ElementRef;
  @Input('Active') public set Active(value: boolean) {
    this.active = value;
  }

  @Input() public fileViewer;
  @Input() public folder;
  @Input() public autoUpload = true;
  @Input() public maxFileSize;
  @Input() public allowedFormats: Array<string> = [];
  @Input() public parseContent = false;

  public progressIsActive = false;
  public windowUploader = false;
  public progressPrecent: number;

  constructor(private requests: RequestsService, private util: UtilsService) {}

  activeUploader() {
    this.active = this.active ? false : true;
  }

  public UploadToCloud(file, temp) {
    const formData = new FormData();
    formData.append('filename', file.name);
    if (temp && temp.id) {
      formData.append('temporary_id', temp.id);
    }
    if (this.storage) {
      formData.append('folder', this.storage.Folder.value);
    } else if (!this.storage && this.folder) {
      formData.append('folder', this.folder);
    }
    formData.append('file', file, file.name);

    const headers = new HttpHeaders({ enctype: 'multipart/form-data' });
    this.requests.DirectUpload(formData, headers).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.Response) {
          const response: IResponse<any> = event.body;
          const items =
            response && response.data && response.data.items
              ? response.data.items
              : [];
          this.uploadFinish.emit(items);
          if (this.storage) {
            this.storage.UpdateItem(items[0], items[0].temporary_id);
          }
        }
        if (event.type === HttpEventType.UploadProgress) {
          this.uploadProgress.emit(event);
        }
      },
      response => {
        this.uploadFailed.emit(response);
        console.error(response);
      }
    );
  }

  uploader(event: any) {
    if (!this.inputFile) {
      return console.error('Cannot find inputFile uploader');
    }
    const files = this.inputFile.nativeElement.files;
    this.fileEvent.next(files);
    this.uploadHandler(files);
  }

  renderAsImage(result, file) {
    return new Promise((resolve, reject) => {
      let width = 0;
      let height = 0;
      const img = new Image();
      img.src = result as string;
      img.onload = () => {
        width = img.width;
        height = img.height;
        resolve(this.createItem(result, file, { width, height }));
      };
    });
  }

  createItem(result, file, meta = {}) {
    const item = {
      id: uuid(),
      src: result,
      filename: file.name,
      size: file.size,
      mimetype: file.type,
      createdAt: new Date(),
      updatedAt: new Date(),
      meta
    } as IImage;
    this.storage.CreateItem(item);
    return item;
  }

  ParseFilesContent(files) {
    for (const file of files) {
      const reader: FileReader = new FileReader();
      reader.onloadend = e => {
        this.util.eventChange.next({
          type: 'TEXTUAL_CONTENT_READ',
          payload: reader.result
        });
      };
      reader.readAsText(file);
    }
  }

  uploadHandler(files) {
    if (this.autoUpload === false) {
      return false;
    }
    if (files.length === 0) {
      return;
    }
    if (!this.FileTypeAllowed(files[0].type)) {
      this.message = ngdTranslate('allowed_file_types', {
        types: this.allowedFormats.join(', ')
      });
      return;
    }
    if (this.parseContent) {
      return this.ParseFilesContent(files);
    }

    this.util.eventChange.next({ type: 'BeginUpload', payload: files });
    for (const file of files) {
      const reader: FileReader = new FileReader();
      reader.onloadend = async e => {
        if (
          file.type === 'image/png' ||
          file.type === 'image/jpg' ||
          file.type === 'image/jpeg'
        ) {
          const temp = await this.renderAsImage(reader.result, file);
          this.UploadToCloud(file, temp);
        } else {
          const temp = this.createItem(reader.result, file);
          this.UploadToCloud(file, temp);
        }
      };
      reader.readAsDataURL(file);
    }
    this.util.eventChange.next({ type: 'EndUpload' });
  }

  FileTypeAllowed(type) {
    if (!this.allowedFormats || this.allowedFormats.includes('*')) {
      return true;
    }
    if (this.allowedFormats.includes(type)) {
      return true;
    }
    return false;
  }

  eventHandler(e) {
    const ele = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - ele.left;
    const y = e.clientY - ele.top;
    switch (e.type) {
      case 'dragover':
        e.preventDefault();
        break;
      case 'dragenter':
        e.preventDefault();
        this.windowUploader = true;
        break;
      case 'dragleave':
        if (x >= ele.width || y >= ele.height || x < 0 || y < 0) {
          this.windowUploader = false;
        }
        break;
    }
  }

  setToFileUploader(e) {
    e.preventDefault();
    this.fileEvent.next(e.dataTransfer.files);
    this.windowUploader = false;
    this.uploadHandler(e.dataTransfer.files);
  }
}
